const secondsToMinute = (seconds: number) => `${(`0${Math.floor(seconds / 60)}`).slice(-2)}:${(`0${Math.floor(seconds % 60)}`).slice(-2)}`;

export default secondsToMinute;
